import { useFeatureFlag } from '@/hooks/useFeatureFlag';

import { columnDefsV1, columnDefsV2 } from './column-defs';

export function useColumnDefs() {
  const isEnabled = useFeatureFlag('Pregnant_Export_Donor_Displaying_Code');
  return isEnabled ? columnDefsV2 : columnDefsV1;
}
